<template>
  <div>
    <v-row class="ma-0 pa-0">
      <v-col :cols="singleRow ? 6 : 12" class="ma-0 pa-0">
        <div :class="{ 'me-3': singleRow }">
          <PasswordField
            class="mb-2"
            :disabled="isLoading"
            :label="`${$t('common.users.new_password_label')}*`"
            :password="password"
            :passwordRules="passwordRules"
            @onChange="handlePasswordChange({ password: $event })"
          />

          <p
            v-if="!password && showDifferentPasswordLabel"
            class="caption ma-0 blue-grey--text"
          >
            {{ $t('common.users.different_password_label') }}
          </p>

          <div>
            <v-progress-linear
              height="7"
              rounded
              :value="passwordStrength.score"
              :color="passwordStrength.color"
            ></v-progress-linear>

            <div class="d-flex justify-space-between mt-1">
              <span class="caption blue-grey--text">{{
                $t('common.security')
              }}</span>
              <span class="caption blue-grey--text">{{
                passwordStrength.text
              }}</span>
            </div>
          </div>
        </div>
      </v-col>

      <v-col :cols="singleRow ? 6 : 12" class="ma-0 pa-0">
        <PasswordField
          :class="{ 'my-4': !singleRow }"
          :disabled="isLoading"
          :passwordRules="confirmPasswordRules"
          :label="confirmPasswordLabel"
          :password="confirmPassword"
          @onChange="handlePasswordChange({ confirmPassword: $event })"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import PasswordField from '@/components/PasswordField.vue'
import passwordMixin from '@/mixins/passwordMixin.vue'

export default {
  name: 'AddPassword',

  mixins: [passwordMixin],

  components: {
    PasswordField,
  },

  props: {
    isLoading: Boolean,
    password: String,
    confirmPassword: String,
    singleRow: Boolean,
    error: {
      type: String,
      default: null,
    },
    customPasswordLabel: String,
    customConfirmPasswordLabel: String,
    showDifferentPasswordLabel: Boolean,
  },

  computed: {
    passwordLabel() {
      return this.customPasswordLabel ?? this.$t('common.users.password')
    },

    confirmPasswordLabel() {
      return (
        this.customConfirmPasswordLabel ??
        this.$t('common.users.confirm_password')
      )
    },

    passwordStrength() {
      return this.getPasswordStrength(this.password)
    },

    passwordRules() {
      return [
        value => {
          if (this.error) return this.error
          if (!value) return this.$t('validation.form.this_field_is_required')
          if (/[<>]/.test(value)) return this.$t('error.invalid_characters')

          return true
        },
      ]
    },

    confirmPasswordRules() {
      return [
        value => {
          if (this.error) return false
          if (!value) return this.$t('validation.form.this_field_is_required')
          return true
        },

        value => {
          if (value !== this.password)
            return this.$t('profile_settings.the_password_not_match')
          return true
        },
      ]
    },
  },

  methods: {
    handlePasswordChange(password) {
      this.$emit('change', password)
    },
  },
}
</script>
